<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card" style="height: 240px;">
        <div class="onboarding-head">
            <div class="onboarding-head-fleft">
                <ol class="breadcrumb-body breadcrumbs-menu">
                    <ng-container *ngFor="let item of campaignUsersTabMenu">
                        <li class="breadcrumbs-menu-item"
                            [class]="(item.value === menuHomeEnumActive) ? 'breadcrumbs-menu-active' : ''"
                            (click)="clickChangeMenuHomeActive(item.value)">{{item.name}}</li>
                    </ng-container>
                </ol>
            </div>
        </div>

        <h5>Total Balance</h5>
        <div style="display: flex; align-items: center;">
            <h1 style="margin-right: 10px; color: black;">{{this.singleCompanyWallet?.CurrentBalanceText}}</h1>
            <h5>/ {{this.singleCompanyWallet?.InitializedBalanceText}}</h5>
            <h3 style="margin-left: auto;">{{this.singleCompanyWallet?.CompanyName}}</h3>
        </div>
        <p-progressBar [value]="this.singleCompanyWallet?.Percentage"></p-progressBar>
    </div>

    <campaign-users-users *ngIf="menuHomeEnumActive === _menuHomeEnum.CampaignUsers_Users"
                          [menuPermissionActive]="menuPermissionActive"
                          [campaignUsersTabMenu]="campaignUsersTabMenu">
    </campaign-users-users>

    <campaign-users-transactions *ngIf="menuHomeEnumActive === _menuHomeEnum.CampaignUsers_Transactions"
                                 [menuPermissionActive]="menuPermissionActive"
                                 [campaignUsersTabMenu]="campaignUsersTabMenu">
    </campaign-users-transactions>
</div>
